// Date formatting helpers that avoid timezone shifts when given YYYY-MM-DD
export const formatLocalDate = (dateStr) => {
  try {
    if (!dateStr) return '';
    const base = String(dateStr).split('T')[0];
    const parts = base.split('-');
    if (parts.length !== 3) return new Date(dateStr).toLocaleDateString();
    const [y, m, d] = parts.map((p) => parseInt(p, 10));
    const dt = new Date(y, (m || 1) - 1, d || 1);
    return dt.toLocaleDateString();
  } catch {
    try { return new Date(dateStr).toLocaleDateString(); } catch { return ''; }
  }
};


